import Axios from "axios";
import { useContext, useEffect, useReducer, useRef, useState } from "react";
import { systemCode, xs_languageCode } from '..';
import { parseLiveData } from "./parseLiveData";
import { dataFetchReducer } from "./data";
import { getConfiguration } from "./utils";
import { BetslipContext } from "./betslip/BetslipConf";

export function useFetchMenuLiveGeneraleNew(sportId,callback,callbackInterval, compattaParametriche) {
    const ctxs = useRef({}).current;
    ctxs.betslipContext =  useContext(BetslipContext);
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    const [isSetInterval,setIsSetInterval] = useState(false);

    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
        
        const url = getConfiguration().api.getMenuLiveGenerale;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sportId
        };
        fetchData(url, params, function(response) {
            const parsedData = response? parseLiveData(response, compattaParametriche):null;
            callback && callback(parsedData);
            dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
        });

        const intervalMillis = getConfiguration()?.lpo ?? 10000;
        const interval =   
        setInterval(() => {
            if(!ctxs?.betslipContext?.betInProgress) {
                setIsSetInterval(true);
                fetchData(url, params, function(response) {
                    const hasResponse = response !== '' && response !=null;
                    if (hasResponse && callbackInterval != null) {
                        const parsedData = parseLiveData(response, compattaParametriche);
                        callbackInterval(parsedData);
                        dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
                    }
                });
            }
        }, intervalMillis);
        
        return () => {
            didCancel = true;
            clearInterval(interval);
            setIsSetInterval(false);
        };
    }, [sportId]);

    return [state, dispatch, isSetInterval];
}
